import { DefaultTemplateOutputs } from '@backstage/plugin-scaffolder-react/alpha';
import type { ScaffolderTaskOutput } from '@backstage/plugin-scaffolder-common';
import { Markdown } from './outputs/Markdown';

export interface ExampleComponentProps {
  output?: ScaffolderTaskOutput;
}

export function CustomTemplateOutputs(props: ExampleComponentProps) {
  const { output } = props;

  return (
    <>
      <DefaultTemplateOutputs output={output} />
      {output?.markdown && <Markdown markdown={output.markdown as string} />}
    </>
  );
}
